"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = __importDefault(require("../../../../scss/colors"));
const Splash = (props) => {
    return (react_1.default.createElement(StyledSplash, null,
        react_1.default.createElement(Background, { backgroundImage: props.splashImage ||
                props.imgSrc ||
                require("../assets/stars.jpg") }),
        react_1.default.createElement(SplashContainer, null,
            react_1.default.createElement(LogoContainer, null,
                react_1.default.createElement(Logo, { src: require("../assets/Stile-Logo.svg") })),
            react_1.default.createElement(TitleContainer, null,
                react_1.default.createElement(Title, null, props.title),
                props.message && react_1.default.createElement(Message, null, props.message)),
            react_1.default.createElement(ButtonContainer, null,
                react_1.default.createElement(LaunchButton, { isVisible: props.viewerReady, onClick: props.splashClick }, "Launch"))),
        react_1.default.createElement(Loader, { isVisible: !props.viewerReady },
            react_1.default.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: "40px", height: "40px", viewBox: "0 0 40 40", enableBackground: "new 0 0 40 40" },
                react_1.default.createElement("path", { opacity: "0.2", fill: "#92e055", d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n                        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n                        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" }),
                react_1.default.createElement("path", { fill: "#92e055", d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n                        C22.32,8.481,24.301,9.057,26.013,10.047z" },
                    react_1.default.createElement("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 20 20", to: "360 20 20", dur: "0.5s", repeatCount: "indefinite" }))))));
};
const StyledSplash = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    color: ${colors_1.default.VRText};
    z-index: 999999;
`;
const Background = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    background-size: cover;
    background-image: url("${(props) => props.backgroundImage}");
    background-position: center;
    &:after {
        content: " ";
        width: 100%;
        height: 100%;
        opacity: 0.7;
        position: absolute;
        left: 0;
        top: 0;
        background-color: ${colors_1.default.VRBackground};
    }
`;
const SplashContainer = styled_components_1.default.div `
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;
const LogoContainer = styled_components_1.default.div `
    width: 100%;
    display: flex;
    justify-content: center;
`;
const Logo = styled_components_1.default.img `
    width: 16rem;
`;
const TitleContainer = styled_components_1.default.div `
    width: 100%;
`;
const Title = styled_components_1.default.h3 `
    text-align: center;
`;
const Message = styled_components_1.default.div `
    font-size: 1em;
    text-align: center;
    padding: 0px 16px;
    line-height: 1.2em;
    margin-top: 15px;
`;
const ButtonContainer = styled_components_1.default.div `
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: center;
`;
const LaunchButton = styled_components_1.default.button `
    background: linear-gradient(-180deg, #00ff64 2%, #00e65a 97%);
    display: ${(props) => (props.isVisible ? "auto" : "none")};
    border-radius: 100px;
    font-size: 20px;
    color: ${colors_1.default.VRBackground};
    letter-spacing: -0.15px;
    text-align: center;
    padding: 1.3rem;
    width: 190px;
    max-width: 80%;
`;
const Loader = styled_components_1.default.div `
    margin: 0 0 2em;
    text-align: center;
    padding: 1em;
    margin: 0 auto 1em;
    display: inline-block;
    vertical-align: top;
    fill: white;
    left: 50%;
    position: absolute;
    top: 60%;
    width: 50px;
    height: 50px;
    transform: translate3d(-100%, -50%, 0);
    display: ${(props) => (props.isVisible ? "auto" : "none")};
`;
exports.default = Splash;
